import moment from 'moment';
import bowser from 'bowser'
//局部显露
export const mixin = {
	data() {
		return {
			wxAppId: 'wxcd032fdf22dc5924',
			//测试环境
			// url: 'http://test-9gameh5.laolongtang.com.cn/callback.html'
			//生产环境
			// url: 'http://9gameh5.laolongtang.com.cn/callback.html'
		}
	},
	methods: {
		//获取浏览器信息
		$getBrowserInfo() {
			const browserData = bowser.getParser(navigator.userAgent)
			const obj = {
				browserName: browserData.getBrowserName(), // 获取浏览器名称
				browserVersion: browserData.getBrowser().version // 获取浏览器版本号
			};
			return obj
		},
		//获取referrer
		$getReferrer() {
			const referrer = document.referrer
			let domain = ''
			if (referrer) {
				const url = new URL(referrer);
				domain = url.hostname // 输出域名的部分
			}
			return domain
		},
		//字符串截取
		truncatedMessage(txt, maxLength) {
			return txt.length > maxLength ? txt.slice(0, maxLength) + '...' : txt;
		},
		//格式化时间
		formattedDate(timestamp) {
		  return moment(timestamp).format('yyyy-MM-DD');
		},
		//解析url参数
		getUrlParam(name) {
			let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
			let r = window.location.search.substr(1).match(reg);
			if (r != null) {
				return unescape(r[2]);
			}
			return null;
		},
		//解析url参数
		getQueryString(path, name) {
			var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
			if (reg.test(path))
				return unescape(RegExp.$2.replace(/\+/g, " "));
			return "";
		},
		
		//判断终端
		isMobile() {
			const ua = navigator.userAgent;
			const isMobileSize = window.innerWidth < 900;
			const isMobileUA = /Mobile|Android|iPhone|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(ua);
			return isMobileSize && isMobileUA; // 同时满足屏幕尺寸和用户代理为手机特征时，认为是手机设备
			
		}
	}
}